import type { SendState } from '@/types/accessor/indexedDB/indexedDB'

/** 有効期限差分。エポックミリ秒で1日分にしている。*/
export const EXPIRATION_DELTA: number = 86400000

/** メソッド */
export const METHOD = {
  GET: 'get',
  UPDATE: 'update',
  DELETE: 'delete'
} as const

/** サーバへの送信状況 */
export const SEND_STATE = {
  /** indexedDB挿入 */
  FETCHED: 'fetched',
  /** indexedDB更新 */
  EDITED: 'edited',
  /** サーバへのアップロード成功 */
  UPLOAD_SUCCESS: 'uploadSuccess',
  /** サーバーへのアップロード失敗 */
  UPLOAD_FAILED: 'uploadFailed'
} as const

/** DynamoDBにアップロード済みSendState */
export const UPLOADED_SEND_STATE: SendState[] = [SEND_STATE.FETCHED, SEND_STATE.UPLOAD_SUCCESS]
